import { SxProps, Theme } from '@mui/material';

export const OrderSummaryBreakdownFrameSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	gap: 0.5,
};

export const OrderSummaryBreakdownTitleSx: SxProps<Theme> = (theme) => ({
	fontWeight: 800,
	fontSize: 'var(--font-size-md)',
	marginBottom: 2,
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-sm)',
	},
});

export const defaultTypographySx: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	display: 'flex',
	alignItems: 'center',
};

export const OrderSummaryBreakdownTotalLabelSx: SxProps<Theme> = {
	fontWeight: 'bold',
	fontSize: 'var(--font-size-body)',
};

export const OrderSummaryBreakdownTotalSx: SxProps<Theme> = {
	fontWeight: 800,
	fontSize: 'var(--font-size-body)',
};

export const OrderSummaryBreakdownDividerSx: SxProps = {
	marginTop: 1,
	marginBottom: 1,
};
